import { render, staticRenderFns } from "./ProductListEditDialog.vue?vue&type=template&id=33215336&scoped=true"
import script from "./ProductListEditDialog.vue?vue&type=script&lang=js"
export * from "./ProductListEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductListEditDialog.vue?vue&type=style&index=0&id=33215336&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33215336",
  null
  
)

export default component.exports